import { colors } from '../../Colors/colors'

export const portalsApplicationsTheme = {
   light: {
      applicationDetailedView: {
         bgPrimary: 'bg-white',
         bgBrandPrimary600: 'bg-primary-600',

         borderPrimary: 'border-gray-300',
         borderBrandPrimary: 'border-primary-600',

         textPrimary: 'text-gray-900',
         textSecondary: 'text-gray-700',
         textSecondary600: 'text-gray-600',
         textTertiary: 'text-gray-500',

         body: {
            categoriesListSection: {},
            categoryDetailedViewSection: {}
         }
      },

      createApplication: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-500',
         card: {
            selectedDescriptionColor: 'text-primary-600',
            selectedTitleColor: 'text-primary-600',
            selectedBorderColor: 'border-primary-600',
            unSelectedBorderColor: 'border-gray-300',
            unSelectedDescriptionColor: 'text-gray-500',
            unSelectedTitleColor: 'text-gray-700'
         }
      },

      applicationsList: {
         headerTextColor: 'text-gray-900',
         borderColor: 'border-gray-300',
         newApplicationHeader: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500'
         },
         noApplicationCard: {
            iconBgColor: 'bg-primary-100',
            titleColor: 'text-gray-800',
            descriptionColor: 'text-gray-600'
         },
         applicationSubmitted: {
            titleColor: 'text-gray-800',
            descriptionColor: 'text-gray-600'
         }
      },
      virtualAssistanceCard: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600'
      }
   },

   dark: {}
}
